var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompButton',{attrs:{"placeholder":"选择店铺","format":"{0}个店铺","value":_vm.value.id ? 1 : 0,"view-btn":false},on:{"click":_vm.handleClickAdd,"remove":_vm.onRemove}})}
var staticRenderFns = []

export { render, staticRenderFns }